import { render, staticRenderFns } from "./ExerciseMedia.vue?vue&type=template&id=7ab72077&scoped=true"
import script from "./ExerciseMedia.vue?vue&type=script&lang=js"
export * from "./ExerciseMedia.vue?vue&type=script&lang=js"
import style0 from "./ExerciseMedia.vue?vue&type=style&index=0&id=7ab72077&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab72077",
  null
  
)

export default component.exports